import { render, staticRenderFns } from "./SkillMainFieldChart.vue?vue&type=template&id=977cacc6"
import script from "./SkillMainFieldChart.vue?vue&type=script&lang=js"
export * from "./SkillMainFieldChart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports